import { pathfinderImage, pathfinderSVG } from "./findPath.js";
import { fourierSeries } from "./fourier.js";
import { epiCycles } from "./epicycles.js";
import { userSketch } from "./userSketch.js";
import { removeCanvas, addScrollEvenListener } from "./util.js";
import pFiveSketch from "./pFiveSketch.js";

import * as p5 from "p5";

const factor = 3;
var n_uploads = 0;

const LOGO = new pFiveSketch();
const USER = new pFiveSketch();

export function mainPathFinder(image, svgBool) {
  if (n_uploads > 0) {
    LOGO.removeP5();
  } else {
    n_uploads++;
    removeCanvas("placeholder");
  }
  if (svgBool) {
    var arr = pathfinderSVG(image, factor);
    myhandler(arr);
  } else {
    pathfinderImage(image.src, myhandler, factor);
  }
  if (n_uploads === 1) {
    //Just uploaded an image for the first time, add event listener.
    addScrollEvenListener(LOGO);
  }
}

function myhandler(arr) {
  let customSketch = function (pFIVE) {
    var x = [];
    let y = [];
    let allFourierX = [];
    let allFourierY = [];
    let numPoints = [];

    let time = 0;
    let localTime = 0;
    let currPath = [[]];
    let currSVGPath = 0;

    pFIVE.setup = function () {
      let cnv = pFIVE.createCanvas(700, 600);
      cnv.parent("upload-sketch");
      cnv.id("logoCanvas");
      pFIVE.frameRate(20);

      for (let subpath of arr) {
        const skip = 2;
        for (let i = 0; i < subpath.length; i += skip) {
          x.push(subpath[i].x);
          y.push(subpath[i].y);
        }

        //The constant terms (the means) are left out so every path is drawn around the chains' origins.
        allFourierX.push(fourierSeries(x).terms);
        allFourierY.push(fourierSeries(y).terms);
        numPoints.push(x.length);

        x.length = 0;
        y.length = 0;
      }
    };
    pFIVE.draw = function () {
      pFIVE.background(255, 255, 255);
      let vx = epiCycles(pFIVE, allFourierX[currSVGPath], Infinity, localTime, 250, 500, 0, "#2f4858");
      let vy = epiCycles(pFIVE, allFourierY[currSVGPath], Infinity, localTime, 550, 200, pFIVE.HALF_PI, "#2f4858");
      let v = pFIVE.createVector(vx.x, vy.y); //As we want coordinate from fourierX and y from fourierY.
      currPath[currSVGPath].push(v);
      pFIVE.line(vx.x, vx.y, v.x, v.y); //Draw the x coordinates of drawing.
      pFIVE.line(vy.x, vy.y, v.x, v.y); //Draw y coordinates of drawing.

      for (let mod = 0; mod < currPath.length; mod++) {
        //When we redraw points. We need a break when we reach the end of an svg path.
        pFIVE.beginShape();
        pFIVE.noFill();
        //Draw all previouse points of drawing for every frame of animation.
        for (let i = 0; i < currPath[mod].length; i++) {
          pFIVE.vertex(currPath[mod][i].x, currPath[mod][i].y);
        }
        pFIVE.endShape();
      }

      const dt = pFIVE.TWO_PI / numPoints[currSVGPath];
      //Should be 2pi a full cycle per frame / the number of fourier coefficents.
      localTime += dt;

      if (localTime >= pFIVE.TWO_PI) {
        //Finsihed one svg path completly.
        time += pFIVE.TWO_PI;
        localTime = 0;
        currSVGPath++;
        currPath.push([]);

        //After we have drawn all paths and been around once, we reset and draw again.
        if (time >= pFIVE.TWO_PI * allFourierX.length) {
          time = 0;
          currPath.length = 0;
          currPath.push([]);
          currSVGPath = 0;
          localTime = 0;
        }
      }
    };
  };
  LOGO.sketchP5 = new p5(customSketch);
}

USER.sketchP5 = new p5(userSketch);

//Adding scroll event listners.
addScrollEvenListener(USER);
